import React from "react";
import aboutme from "../../assets/7SvE-unscreen.gif";
import AOS from "aos";
import "aos/dist/aos.css";
import { GrFacebookOption, GrLinkedinOption, GrGithub } from "react-icons/gr";
import ButtonCommon from "../ButtonCommon/ButtonCommon";
const AboutMe = () => {
  AOS.init({
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 200,
  });
  return (
    <div id="about" className=" mx-auto  py-16  overflow-hidden">
      <div className="flex relative after:absolute after:content-['About']  after:tracking-widest after:text-own-gray-black after:text-[6rem]   sm:after:text-[8rem] after:opacity-70 after:left-[50%] after:-translate-x-[50%] after:top-0 MyContainer pt-20 after:font-semibold after:-z-10 justify-center  md:flex-row flex-col ">
        <div
          data-aos="zoom-in"
          className="md:w-[500px]  mb-16 md:mb-0  relative  after:absolute  after:w-[100%] after:h-[100%] after:top-0 after:left-0  after:bg-own-primary  flex justify-center items-center after:animate-bounce after:opacity-30 after:border-b-2 after:border-opacity-5  after:shadow-md "
        >
          <img className="relative " src={aboutme} alt="" />
        </div>
        <div data-aos="zoom-in" className="p-6 mb-3 md:w-[50%]">
          <h2 className="lg:text-5xl text-2xl  font-bold  text-own-gray-white py-3 flex flex-col">
            Sohag Hossain <span className="text-own-secondary mt-3">Zayan</span>
          </h2>
          {/* <h2 className="lg:text-3xl text-xl  font-bold text-own-secondary mb-3">
            MERN Stack Developer
          </h2> */}

          <p className="mb-2 text-own-gray-white text-justify">
            I a'm MERN-Stack WEB Developer. I am working with{" "}
            <span className="text-own-secondary font-medium">React Js</span>,{" "}
            <span className="text-own-secondary font-medium">Next Js</span>,
            <span className="text-own-secondary font-medium"> Redux</span>,
            <span className="text-own-secondary font-medium"> NodeJS</span>{" "}
            <span className="text-own-secondary font-medium">Express Js </span>
            and <span className="text-own-secondary font-medium"> MongoDB</span>
            . I also have experience in developing static websites using{" "}
            <span className="text-own-secondary font-medium">HTML5</span>,{" "}
            <span className="text-own-secondary font-medium">CSS3</span> and{" "}
            <span className="text-own-secondary font-medium">
              JavaScript (ES6)
            </span>{" "}
            . I a'm quick learner. I believe in hard work and efficiency. That's
            why I am always ready to accomplish any task by working hard. I
            always focus on learning new technology. My goal is to become A
            World-Class Professional Web Developer.
          </p>
          <div className="flex  gap-5 mb-2">
            <span className="border-2 border-own-border-color hover:border-transparent hover:bg-own-secondary group p-2 border-opacity-20 transition-all delay-100 ease-in w-10 h-10 rounded-full flex items-center justify-center group">
              <GrFacebookOption className="text-2xl group-hover:text-own-gray-white text-own-secondary transition-all delay-100 ease-in" />
            </span>
            <span className="border-2 border-own-border-color hover:border-transparent hover:bg-own-secondary group p-2 border-opacity-20 transition-all delay-100 ease-in w-10 h-10 rounded-full flex items-center justify-center group">
              <GrLinkedinOption className="text-2xl group-hover:text-own-gray-white text-own-secondary transition-all delay-100 ease-in" />
            </span>
            <span className="border-2 border-own-border-color hover:border-transparent hover:bg-own-secondary group p-2 border-opacity-20 transition-all delay-100 ease-in w-10 h-10 rounded-full flex items-center justify-center group">
              <GrGithub className="text-2xl group-hover:text-own-gray-white text-own-secondary transition-all delay-100 ease-in" />
            </span>
          </div>
          {/* <ButtonCommon /> */}

          <ButtonCommon>Download CV</ButtonCommon>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
